import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import queryString from "query-string";
import {
  faUser,
  faAngleLeft,
  faEnvelope,
  faUnlockAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
  Modal,
} from "@themesberg/react-bootstrap";
import { Routes } from "../../routes";

import { FormattedMessage } from "react-intl";

const ResetSuccess = () => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5"><FormattedMessage id="changeCompPassword" /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <FormattedMessage id="changedPassword" />
          <br />
          <FormattedMessage id="plzLogin" />
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button href={Routes.Signin.path} variant="secondary">
        <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default () => {
  const [input, setInput] = useState({ pwd: "", pwd2: "" });
  const [msg, setMsg] = useState("");
  const [user_id, setUserId] = useState(0);
  const [success, setSuccess] = useState(false);

  const location = useLocation();
  const history = useHistory();

  const { pwd, pwd2 } = input;
  const query = queryString.parse(location.search);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + `/api/reset?token=${query.token}`, {
      method: "get",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          history.push("/404");
          return;
        } else {
          return resp.json();
        }
      })
      .then((resp) => {
        if (resp.user) {
          setUserId(resp.user);
        }
      });
  }, [history, query, user_id]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  };
  const onSubmit = (e) => {
    e.preventDefault();

    if (!pwd || !pwd2) {
      setMsg("비밀번호를 입력해주세요.");
      return;
    } else if (pwd !== pwd2) {
      setMsg("비밀번호가 일치하지 않습니다.");
      return;
    }

    fetch(process.env.REACT_APP_API_URL + "/api/update", {
      method: "post",
      body: JSON.stringify({
        password: pwd,
        user_id,
      }),
    }).then((resp) => {
      if (resp.status === 200) {
        setSuccess(true);
      } else {
        setMsg("다시 시도해주세요.");
      }
    });
  };

  return (
    <main>
      <section className="bg-soft d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Row className="justify-content-center">
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <h3 className="mb-4"><FormattedMessage id="resetPassword" /></h3>
                <Form>
                  <Form.Group id="password" className="mb-4">
                    <Form.Label><FormattedMessage id="newPassword" /></Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="password"
                        placeholder="Password"
                        value={pwd}
                        name="pwd"
                        onChange={onChange}
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group id="confirmPassword" className="mb-4">
                    <Form.Label><FormattedMessage id="newPassword" /> <FormattedMessage id="confirm" /></Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="password"
                        placeholder="Confirm Password"
                        value={pwd2}
                        name="pwd2"
                        onChange={onChange}
                      />
                    </InputGroup>
                  </Form.Group>
                  {msg && <p className="text-danger">{msg}</p>}
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    onClick={onSubmit}
                  >
                    <FormattedMessage id="trychangePassword" />
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {success && <ResetSuccess />}
    </main>
  );
};
